import { render, staticRenderFns } from "./DeviceDocField.vue?vue&type=template&id=598b3e18&scoped=true"
import script from "./DeviceDocField.vue?vue&type=script&lang=js"
export * from "./DeviceDocField.vue?vue&type=script&lang=js"
import style0 from "./DeviceDocField.vue?vue&type=style&index=0&id=598b3e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598b3e18",
  null
  
)

export default component.exports